
/**
 * A function that returns the URL part common to the endpoints.
 */
export const root = () => {
    let __root = "";
    
    if (process.env.RUNTIME_ENV === "local") {       
        __root = "http://localhost:7999";
    }

    if (process.env.RUNTIME_ENV === "development") {       
        __root = "https://api-cleaning.dev.m2msystems.cloud";
    }

    if (process.env.RUNTIME_ENV === "production") {       
        __root = "https://api-cleaning.m2msystems.cloud";
    }
    return __root
}

/**
 * TTLockのキー番号を取得する
 * 
 */
export const getTTLockKeyNumberByListingId = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/ttlock/keyNumber/${listingId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getTTLockKeyNumberByListingId.method = "GET" as const;

/**
 * TTLock情報をlistingIdから取得する
 * 
 */
export const getTTLockByListingId = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/ttlock/listing/${listingId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getTTLockByListingId.method = "GET" as const;

/**
 * 清掃員がTTLockのeKeyを取得する
 * 
 */
export const getTTLockEKeyForCleaner = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/ttlock/ekey`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getTTLockEKeyForCleaner.method = "POST" as const;

/**
 * 自分に対する Feature Flag の評価結果を取得する
 * 
 */
export const getCleanerFeatureFlags = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/feature_flags`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleanerFeatureFlags.method = "GET" as const;

/**
 * 清掃員が単価承認リクエストを拒否
 * 
 */
export const rejectPendingApprovalRequest = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/approvalRequest/rejected/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
rejectPendingApprovalRequest.method = "POST" as const;

/**
 * 清掃員が単価承認リクエストを取得する
 * 
 */
export const getReportedApprovalRequestsByDays = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/approval_requests/reported/days`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getReportedApprovalRequestsByDays.method = "POST" as const;

/**
 * 清掃員が日付で清掃を取得する
 * 
 */
export const findCleaningsByDates = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner/cleanings/search/dates`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleaningsByDates.method = "POST" as const;

/**
 * 清掃員のネイティブアプリログイン情報を記録する
 * 
 */
export const saveNativeAppActivity = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_native_app_activity`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveNativeAppActivity.method = "POST" as const;

/**
 * 清掃員用の通知を取得する
 * 
 */
export const getCompanyNotificationForCleaner = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/company_notification/cleaner`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCompanyNotificationForCleaner.method = "GET" as const;

/**
 * 清掃員が自分がインセンティブ対象かどうかを確認する
 * 
 */
export const isIncentiveTarget = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/incentive_target_cleaners/me`;
    return __queries ? `${__path}?${__queries}` : __path;
};
isIncentiveTarget.method = "GET" as const;

/**
 * 清掃員自身の情報を取得する
 * 
 */
export const findCleanerProfileForCleaner = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/me`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleanerProfileForCleaner.method = "GET" as const;

/**
 * 清掃員が交通費を申請する
 * 
 */
export const registerTransportationExpense = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/transportation_expenses/register`;
    return __queries ? `${__path}?${__queries}` : __path;
};
registerTransportationExpense.method = "POST" as const;

/**
 * 清掃員が交通費申請を修正する
 * 
 */
export const updateTransportationExpense = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/transportation_expenses/update`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateTransportationExpense.method = "POST" as const;

/**
 * 清掃員が自分の交通費申請一覧を取得する
 * 
 */
export const listTransportationExpensesByCleaner = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/transportation_expenses/list_for_cleaner`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listTransportationExpensesByCleaner.method = "POST" as const;

/**
 * 清掃員が下請法の書面を取得する
 * 
 */
export const getSubContractDocumentByApprovalRequestId = ({approvalRequestId}: {approvalRequestId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/approval_request/${approvalRequestId}/sub_contract_document`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getSubContractDocumentByApprovalRequestId.method = "GET" as const;

/**
 * 清掃員が下請法の書面PDFを取得する
 * 
 */
export const createSubContractDocumentPdfByApprovalRequestId = ({approvalRequestId}: {approvalRequestId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/approval_request/${approvalRequestId}/create_pdf`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createSubContractDocumentPdfByApprovalRequestId.method = "GET" as const;

/**
 * 清掃員が清掃の追加情報を取得する
 * 
 */
export const getCleaningExtraInfo = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/extra_info`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaningExtraInfo.method = "GET" as const;

/**
 * 清掃員がスペアキーボックスの鍵番号を取得する
 * 
 */
export const getSpareKeyboxNumber = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/spare_keybox`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getSpareKeyboxNumber.method = "GET" as const;

/**
 * 清掃員がスペアキーボックスの最新鍵番号を取得する
 * 
 */
export const getLatestSpareKeyboxNumber = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/spare_keybox/latest`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getLatestSpareKeyboxNumber.method = "GET" as const;

/**
 * 清掃員がスペアキーボックス写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueSpareKeyboxPictureUploadUrl = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/spare_keybox/picture/uploadUrl`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueSpareKeyboxPictureUploadUrl.method = "POST" as const;

/**
 * 清掃員がスペアキーボックスの鍵を変更する（S3直接アップロード後の完了通知）
 * 
 */
export const completeSpareKeyboxRotation = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/spare_keybox/rotate/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeSpareKeyboxRotation.method = "POST" as const;

/**
 * 清掃員がスペアキーボックスの鍵を変更する
 * 
 */
export const rotateSpareKeyboxNumber = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/spare_keybox/rotate`;
    return __queries ? `${__path}?${__queries}` : __path;
};
rotateSpareKeyboxNumber.method = "POST" as const;

/**
 * 清掃員がフォトツアーの画像を削除する
 * 
 */
export const deletePhotoTourImageByCleaner = ({operationId, imageId}: {operationId: string, imageId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/operations/${operationId}/photoTourImage/${imageId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deletePhotoTourImageByCleaner.method = "DELETE" as const;

/**
 * 清掃員がフォトツアーの動画を削除する
 * 
 */
export const deletePhotoTourMovieByCleaner = ({operationId, movieId}: {operationId: string, movieId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/operations/${operationId}/photoTourMovie/${movieId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deletePhotoTourMovieByCleaner.method = "DELETE" as const;

/**
 * 清掃員が清掃に紐づくゴミストッカー見本写真を取得する（物件上書きが無ければ global へフォールバック）
 * 
 */
export const getGarbageStorageSampleImageForCleaner = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/garbage-storage/sample-image`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getGarbageStorageSampleImageForCleaner.method = "GET" as const;

/**
 * 清掃員がゴミ庫チェック写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueGarbageStorageCheckImageUploadUrl = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/garbage-storage/check/upload-url`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueGarbageStorageCheckImageUploadUrl.method = "POST" as const;

/**
 * 清掃員がゴミ庫の溢れチェックを報告する（S3直接アップロード後の完了通知）
 * 
 */
export const completeGarbageStorageCheck = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/garbage-storage/check`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeGarbageStorageCheck.method = "POST" as const;

/**
 * 清掃員がゴミ庫の溢れチェック報告を取得する（未報告なら null）
 * 
 */
export const getGarbageStorageCheck = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/garbage-storage/check`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getGarbageStorageCheck.method = "GET" as const;

/**
 * 清掃員が清掃に紐づくゴミストッカーの鍵情報を取得する（未設定なら null）
 * 
 */
export const getGarbageStorageKeyInfoForCleaner = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/garbage-storage/key-info`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getGarbageStorageKeyInfoForCleaner.method = "GET" as const;

/**
 * 清掃員が清掃をゴミ庫チェックの報告対象か確認する（エリアで判定。現状は東京のみ対象）
 * 
 */
export const getGarbageStorageCheckTarget = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/garbage-storage/check-target`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getGarbageStorageCheckTarget.method = "GET" as const;

/**
 * 清掃員が忘れ物の保管場所の写真をS3に直接アップロードするためのPresigned URLを取得する
 * 
 */
export const issueLostItemReportImageUploadUrl = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/lost-items/upload-url`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueLostItemReportImageUploadUrl.method = "POST" as const;

/**
 * 清掃員が忘れ物を1件報告する（S3直接アップロード後の完了通知。貴重品は1物品1件）
 * 
 */
export const createLostItemReport = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/lost-items`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createLostItemReport.method = "POST" as const;

/**
 * 清掃員が清掃に紐づく忘れ物報告を一覧取得する（報告が無ければ空配列）
 * 
 */
export const getLostItemReports = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/lost-items`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getLostItemReports.method = "GET" as const;

/**
 * 清掃員が誤って報告した忘れ物を削除する（Slack未通知の報告のみ削除できる）
 * 
 */
export const deleteLostItemReport = ({cleaningId, reportId}: {cleaningId: string, reportId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/lost-items/${reportId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteLostItemReport.method = "DELETE" as const;

/**
 * 清掃員が清掃を忘れ物報告の対象か確認する（エリアで判定。現状は東京のみ対象）
 * 
 */
export const getLostItemReportTarget = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/lost-items/target`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getLostItemReportTarget.method = "GET" as const;

/**
 * 清掃員が備品チェック対象物件の品目リストを取得する（対象外なら isEnabled=false）
 * 
 */
export const getRoomSupplyItems = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/room-supply/items`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getRoomSupplyItems.method = "GET" as const;

/**
 * 清掃員が備品の不足報告を送信する（品目＋数量）
 * 
 */
export const completeRoomSupplyReport = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/room-supply/report`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeRoomSupplyReport.method = "POST" as const;

/**
 * 清掃員が備品の不足報告を取得する（未報告なら null）
 * 
 */
export const getRoomSupplyReport = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/${cleaningId}/room-supply/report`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getRoomSupplyReport.method = "GET" as const;
export const m2mCleaning_cleanerV4 = {getTTLockKeyNumberByListingId,getTTLockByListingId,getTTLockEKeyForCleaner,getCleanerFeatureFlags,rejectPendingApprovalRequest,getReportedApprovalRequestsByDays,findCleaningsByDates,saveNativeAppActivity,getCompanyNotificationForCleaner,isIncentiveTarget,findCleanerProfileForCleaner,registerTransportationExpense,updateTransportationExpense,listTransportationExpensesByCleaner,getSubContractDocumentByApprovalRequestId,createSubContractDocumentPdfByApprovalRequestId,getCleaningExtraInfo,getSpareKeyboxNumber,getLatestSpareKeyboxNumber,issueSpareKeyboxPictureUploadUrl,completeSpareKeyboxRotation,rotateSpareKeyboxNumber,deletePhotoTourImageByCleaner,deletePhotoTourMovieByCleaner,getGarbageStorageSampleImageForCleaner,issueGarbageStorageCheckImageUploadUrl,completeGarbageStorageCheck,getGarbageStorageCheck,getGarbageStorageKeyInfoForCleaner,getGarbageStorageCheckTarget,issueLostItemReportImageUploadUrl,createLostItemReport,getLostItemReports,deleteLostItemReport,getLostItemReportTarget,getRoomSupplyItems,completeRoomSupplyReport,getRoomSupplyReport};
